import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')

const ROUTE_NAME = 'profile:acts:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        label: 'ACTS_LIST',
        accessConfig: accessPermission([TYPES.DEALER], options),
      },
    }),
    route(':id/detail/', Display, DISPLAY, {
      meta: {
        label: 'ACTS_DETAIL',
        accessConfig: accessPermission([TYPES.DEALER], options),
      },
      props: true,
    }),
  ]
}
